	/*
 * @Author: your name
 * @Date: 2020-03-26 15:35:04
 * @LastEditTime: 2020-03-28 09:11:28
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \Project\src\vueX\store.js
 */
import Vue from 'vue'
import Vuex from 'vuex'
import defaultImgOptions from './model/defaultImgOptions'
import defaultChartsOptions from './model/defaultChartsOptions'
import defaultThreeMap from './model/defaultThreeMap'
import mutations from './mutations.js'

Vue.use(Vuex);

const store = new Vuex.Store({
    //VueX 状态和数据存放对象
    state: {
        mask:false,
        networkError:false,
        userData:{},  //用户信息
        userConfig:{    //用户配置
            rowsPerPage:10,
            overview:[],
            homepage:'/CompanyConsole/IndexEditShow',
            mute:0,
        },
        companyId:null,    //用户操作的企业id
        companyName:'', //用户操作的企业名称
        companyTitle: '', //用户操作的企业标题
        companyCode:'', //用户操作的企业编码
        companyCreatedTime: 1559577600000, //用户操作的企业创建时间
        companyLogo:'', //企业logo
        treeData:[],    //组织树
        deviceTreeData:[],  //设备树
        deviceTreeType:1,   //设备树类型
        isLook:false,   //查看模式
        imgUrl:"",  //图片地址前缀http://iot.yonjie.com
        MQTT_SERVICE:'ws://mqtt.yonjie.com:8083/mqtt', //mqtt服务器地址 mqtt.yonjie.com  192.168.3.12
        headerActive:0, //运维中心头部背景
        userMenus:[],
        functionList:[],
        loginState:false, //登录状态
        activeIndex:'1',  //左侧导航选中对象
        energyIndex:"/Energy/index",   //能源管理左侧导航选中对象
        mobState:0,       //移动端导航状态
        indexEditStep: 0, //企业运维大屏操作步数
        openId:'',        //微信端openID
        wechatBindState:false,  //微信绑定状态
        client:false,     //mqtt对象
        nazeki:false,	  //组态编辑Alt看板mqtt对象
        subaru:false,     //预览时mqtt对象
        buerga:false,	  //组态地图状态灯mqtt
        expandedArr:[],
        messageList:[],
        isEdit:false,   //当前页面是否编辑过
        HTMLminWidth: 1560,
        shotImg: '',//当前组态地图的小地图缩略图
        layout:false,
        fontSize:null,
        ProductFeature:[],
        energyTree:[],
        energyShow:false,   //是否显示能源管理
        broadcasting:false, //是否正在播放
        // 首页编辑
        DragList:[],    //拖拽节点数组
        activeItem:[],  //使用数组保存 实际使用为activeItem[0]
        activeList:[],
        activeDragList:[],
        activePanel:[],
        activePanelList:[],
        panelParentIds:[],  //当前面板所有父级id集合
        DragId:0,
        vLine:[],
        hLine:[],
        motherboadrArr:[{id:0,name:'默认文件夹',children:[]}], //母版数据,
        notAllowed:false,
        mouseMove:false, //拖动控件蒙层
        scale:1,
        viewType:"web",
        viewWidth:1920,   // 画布宽
        viewHeight:1080,  // 画布高
        canvasBgColor:"#151515",  //画布背景
        activeBlockShow:false,  //动态面板激活状态的背景盒子
        indexPreviewData:[],
        deviceWarningList:[],
        companyIndexPreviewUrl:"/CompanyConsole/IndexEditShow",
        mqttUrlList:[],
        panelChildrenList:[{list:[]}],   //动态面板当前激活面板的子组件 - 大纲
        FocusInput:null,//
        changTimeObj:{},
        productList:[],
        updateControl:1,
        updateNavMenu:1,
        Processing:false, //大屏点击事件节流
        showManualInput:false,
        ManualInputObj:null,
        editProupId:null, //当前激活的弹窗id
        showProupId:null, //Preview显示的弹窗id
        proupItem:{},     //当前激活的弹窗
        childrenProupEdit:false,  //面板子弹窗组件是否正在编辑
    },
	modules:{
		defaultImgOptions,  //编辑器
		defaultChartsOptions,   //图表配置
		defaultThreeMap,
    },
    mutations:mutations
})
export default store



// WEBPACK FOOTER //
// ./src/vueX/store.js